import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { RoleService } from './role.service';

@Directive({
  selector: '[grantAccess]',
})
export class GrantAccessDirective {

  private hasView = false;

  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef,
    private roleService: RoleService) { }

  @Input() set grantAccess(path: string) {
    let hasPermission: boolean;
    this.roleService.getPermissionsByCurrentUser()
    .forEach(response => {
      response.result.forEach(permission => {
        if (`${permission}/` == path) hasPermission = true;
      });
      if (hasPermission && !this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      } else if(!hasPermission && this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
    });
  }
}
